import React from "react";
import { number, func, string, object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { WithFacebookLogin } from "@quintype/components";

import { getUser } from "../../utils/api";
import { setAccessTypeUser, getUserSubscriptions, loadAccessType } from "../../helper/access-type";

import SocialAuthButton from "../social-auth-button";

const FacebookAuth = ({ facebookId, setMember, setLoading, closePopup, setUserPlans, env, accessTypeV2 }) => {
  const socialLogin = (e, login) => {
    e.preventDefault();

    setLoading(true);

    loadAccessType(accessTypeV2.accountKey, env, loginCallback);

    function loginCallback() {
      login()
        .then(() => {
          // Fetch the user details
          getUser()
            .then(result => {
              setMember(result.user);

              closePopup && closePopup();
              const { user } = result;

              setAccessTypeUser(user.email, user["phone-number"], user.id, user.name).then(() => {
                getUserSubscriptions().then(data => {
                  setUserPlans(data.subscriptions);

                  setLoading(false);
                });
              });
            })
            .catch(() => setLoading(false));
        })
        .catch(() => setLoading(false));
    }
  };

  return (
    <WithFacebookLogin appId={facebookId} scope="email" emailMandatory loginHandler="bridgekeeper">
      {({ login, serverSideLoginPath }) => (
        <SocialAuthButton type="fb" href={serverSideLoginPath} onSocialClick={e => socialLogin(e, login)} />
      )}
    </WithFacebookLogin>
  );
};

FacebookAuth.propTypes = {
  facebookId: number,
  setMember: func.isRequired,
  setLoading: func.isRequired,
  closePopup: func,
  setUserPlans: func,
  env: string,
  accessTypeV2: object
};

const mapStateToProps = state => ({
  env: get(state, ["qt", "config", "publisher-attributes", "env"], "production"),
  accessTypeV2: get(state, ["qt", "config", "publisher-attributes", "accessTypeV2"], {})
});

export default connect(
  mapStateToProps,
  null
)(FacebookAuth);
